export function isEmptyObject(value: Record<string, unknown>) {
  return Object.keys(value).length === 0 && value.constructor === Object;
}
